import { DriversLicence } from './drivers-licence';
import { Passport } from './passport';

export namespace Identification {
  export interface SchemaPropertyDefinition {
    passport: Passport.SchemaPropertyDefinition;
    driverLicence: DriversLicence.SchemaPropertyDefinition;
  }

  export interface SchemaContract {
    passport?: Passport.SchemaContract | null;
    driverLicence?: DriversLicence.SchemaContract | null;
  }

  export interface Model {
    passport: Passport.Model;
    driverLicence: DriversLicence.Model;
  }

  export function toModel(contract: SchemaContract): Model {
    return {
      passport: contract.passport
        ? Passport.toModel(contract.passport)
        : Passport.toModel({}),
      driverLicence: contract.driverLicence
        ? DriversLicence.toModel(contract.driverLicence)
        : DriversLicence.toModel({})
    };
  }

  export function toSchemaContract(
    model: Partial<Model>
  ): Partial<SchemaContract> {
    return {
      passport: model.passport
        ? Passport.toSchemaContract(model.passport)
        : undefined,
      driverLicence: model.driverLicence
        ? DriversLicence.toSchemaContract(model.driverLicence)
        : undefined
    };
  }
}
